import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'

export type RequestSecondSignatureCodeResponse = {
  reused: boolean
  invalidated: boolean
  attemptsRemaining: number
  maskedEmail: string
  expiresAt: string
  resendAvailableAt: string
}

export type SecondSignatureCodeTarget = {
  signerId: string
  // Pattern's _id when editing, generated residentMedicationId when adding.
  subjectId: string
}

const useRequestSecondSignatureCode = () => {
  const mutation = useMutation(
    ({ signerId, subjectId }: SecondSignatureCodeTarget) =>
      postJSON({
        url: '/emar/second-signature-codes/request-code',
        json: { signerId, subjectId }
      })
  )

  return {
    requestCode: mutation.mutateAsync as (
      target: SecondSignatureCodeTarget
    ) => Promise<RequestSecondSignatureCodeResponse>,
    isLoading: mutation.isLoading
  }
}

export default useRequestSecondSignatureCode
